import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-saved-list",
  "use": "icon-saved-list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-saved-list\">\n  <path d=\"M11.0031 1.5H5.00179C4.60388 1.5 4.22227 1.65807 3.9409 1.93944C3.65953 2.2208 3.50146 2.60242 3.50146 3.00033V14.5028L8.00244 10.502L12.5034 14.5028V3.00033C12.5034 2.60242 12.3454 2.2208 12.064 1.93944C11.7826 1.65807 11.401 1.5 11.0031 1.5Z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol